import React from 'react';
import { Typography, Input } from 'antd';
import { CustomTooltip } from './custom-tooltip';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

const { Text } = Typography;
const { TextArea } = Input;

interface InputFieldProps {
  field: any;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  commonStyle: React.CSSProperties;
  labelStyle: React.CSSProperties;
  error?: string;
}

export const InputField: React.FC<InputFieldProps> = ({
  field,
  value,
  onChange,
  onBlur,
  commonStyle,
  labelStyle,
  error
}) => {
  const { fontSize } = useResponsiveSizes();

  // Detectar si el campo debe ser multilinea
  const isMultiline = field.multiline;

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>
      <CustomTooltip field={field}>
        {isMultiline ? (
          <TextArea
            placeholder={field.placeholder}
            style={{ fontSize: commonStyle.fontSize }}
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            status={error ? 'error' : undefined}
            autoSize={{ minRows: 3, maxRows: 8 }}
            showCount={field.maxLength ? true : false}
            maxLength={field.maxLength}
          />
        ) : (
          <Input
            placeholder={field.placeholder}
            style={{ fontSize: commonStyle.fontSize }}
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            status={error ? 'error' : undefined}
          />
        )}
      </CustomTooltip>
      {error && (
        <Text type='danger' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
